module.exports = __webpack_public_path__ + "img/9.ee508b87.jpg";